import React from 'react';
import styled, { css } from 'styled-components';
import { comma } from '@zillow/formatters';
import {
    token,
    Text,
    Popper,
    Popover,
    Heading,
    mediaMixin,
    spaceMixin,
    Paragraph,
    Flex,
} from '@zillow/constellation';
import type { Property } from '../types/@zillow-types/pongo';

const StyledDiv = styled.div`
    background-color: ${token('colors.white')};
    border-style: solid;
    border-radius: 3px;
    border-width: 1px;
    border-color: ${token('colors.gray300')};
    padding: ${spaceMixin(3)} ${spaceMixin(2)};

    ${mediaMixin(
        'md_lte',
        css`
            padding: ${spaceMixin(1.25)};
        `
    )};
`;

const StyledPopper = styled(Popper)`
    bottom: ${spaceMixin(0.4)};
    left: ${spaceMixin(0.5)};
`;

const Buffer = styled.div`
    border-bottom: 2px dashed ${token('colors.gray300')};
    flex: 1;
    margin: 0 ${spaceMixin(1.25)} ${spaceMixin(0.5)};
`;

function TooltipContent() {
    return (
        <Paragraph>
            A <b>Zestimate®</b> home valuation is Zillow’s estimated market value. It is not an
            appraisal. Use it as a starting point to determine a home’s value.{' '}
            <a href="/zestimate">Learn more</a>
        </Paragraph>
    );
}

interface HomeValueProps {
    zestimate: Property['zestimate'];
}

const HomeValue = ({ zestimate }: HomeValueProps) => (
    <StyledDiv data-testid="home-value">
        <Text fontType="h6">Your home value</Text>
        <Flex display="flex" marginTop="sm" alignItems="flex-end">
            <Text fontType="h5" fontColor="textDark">
                Zestimate
            </Text>
            <StyledPopper
                triggered={
                    <Popover
                        header={<Heading level={6}>Zestimate</Heading>}
                        body={<TooltipContent />}
                    />
                }
            />
            <Buffer />
            <Text fontType={{ default: 'h5', md: 'h4' }} fontColor="textDark">
                {zestimate ? `$${comma(zestimate)}` : 'N/A'}
            </Text>
        </Flex>
    </StyledDiv>
);

export default HomeValue;
